export default __webpack_public_path__ + "static/media/location.a6854d64.png";